import { AxiosResponse } from 'axios';
import { IncomingHttpHeaders } from 'http';
import { Jp_doda_hydrogen_presentation_v2_response_IndustryLargeResponse } from '@doda/api-client/aspida/@types';
import { appAxios } from '../../../libs/axios/appAxios';

export const getIndustry = async (headers: IncomingHttpHeaders) => {
  return appAxios({
    url: '/api/v2/industry',
    headers,
  }).then(
    (
      res: AxiosResponse<
        Jp_doda_hydrogen_presentation_v2_response_IndustryLargeResponse[]
      >
    ) => {
      return res.data;
    }
  );
};

export const getIndustryMasterSort = async (headers: IncomingHttpHeaders) => {
  return appAxios({
    url: '/api/v2/industry',
    params: { sortKey: 'master' },
    headers,
  }).then(
    (
      res: AxiosResponse<
        Jp_doda_hydrogen_presentation_v2_response_IndustryLargeResponse[]
      >
    ) => {
      return res.data;
    }
  );
};
